import { SizeGroup, Taxon } from '../../typings/base'
import { ACTIONS } from '../actions/taxons'

export interface TaxonsReducerState {
  loading: boolean
  loadingAttribute?: boolean
  loadingSizes?: boolean
  attributesSlug?: string
  isSecondHand?: boolean
  sizesCode?: string
  attributes?: any
  sizes?: SizeGroup[]
  sizesNamePositionMap?: Record<string, number>
  items: Taxon[]
  locale: string
  error?: any
  attributeValues?: Record<
    string,
    { values: any[]; locale: string; loading?: boolean }
  >
}

export const initialProductsState: TaxonsReducerState = {
  loading: false,
  items: [],
  loadingAttribute: false,
  loadingSizes: false,
  locale: '',
  attributeValues: {},
}

const taxonsReducer = (
  state = initialProductsState,
  action
): TaxonsReducerState => {
  switch (action.type) {
    case ACTIONS.GET_TAXONS_REQUEST:
      return { ...state, loading: true }
    case ACTIONS.GET_TAXONS_ATTRIBUTES_REQUEST:
      return { ...state, loadingAttribute: true }
    case ACTIONS.GET_TAXONS_SIZES_REQUEST:
      return { ...state, loadingSizes: true }
    case ACTIONS.GET_TAXONS_SUCCESS:
      return {
        ...state,
        items: action.taxons,
        locale: action.locale,
        loading: false,
      }
    case ACTIONS.GET_TAXONS_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loadingAttribute: false,
        attributesSlug: action.slug,
        attributes: action.attributes,
        isSecondHand: action?.isSecondHand,
      }
    case ACTIONS.GET_TAXONS_SIZES_SUCCESS:
      return {
        ...state,
        loadingSizes: false,
        sizesCode: action.code,
        sizes: action.sizes,
        sizesNamePositionMap: action.sizes
          .find((sizeGroup) => sizeGroup.code === 'size')
          ?.sizes.reduce((acc, size) => {
            acc[size.name] = size.position
            return acc
          }, {}),
      }
    case ACTIONS.GET_TAXONS_FAILURE:
      return { ...state, loading: false, error: action.error }
    case ACTIONS.GET_TAXONS_ATTRIBUTES_FAILURE:
      return { ...state, loadingAttribute: false, error: action.error }
    case ACTIONS.GET_TAXONS_SIZES_FAILURE:
      return { ...state, loadingSizes: false, error: action.error }
    case ACTIONS.GET_ATTRIBUTE_VALUES_REQUEST:
      return {
        ...state,
        attributeValues: {
          ...state.attributeValues,
          [action.attributeCode]: {
            ...state.attributeValues?.[action.attributeCode],
            loading: true,
          },
        },
      }
    case ACTIONS.GET_ATTRIBUTE_VALUES_SUCCESS:
      return {
        ...state,
        attributeValues: {
          ...state.attributeValues,
          [action.attributeCode]: {
            values: action.values.choices,
            locale: action.locale,
            loading: false,
          },
        },
      }
    case ACTIONS.GET_ATTRIBUTE_VALUES_FAILURE:
      return {
        ...state,
        attributeValues: {
          ...state.attributeValues,
          [action.attributeCode]: {
            ...state.attributeValues?.[action.attributeCode],
            loading: false,
          },
        },
        error: action.err,
      }
    default:
      return state
  }
}

export default taxonsReducer
